import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
      providedIn: 'root'
})
export class MeetingService {
  http: any;
  baseUrl: String;
  headers: any;
  options: any;

  constructor(http: HttpClient) {

    this.http = http;
    // this.baseUrl = 'http://ovo.dev.bluelightit.com/mrapi/meetingrooms/v1/index.php';
    this.baseUrl = 'https://book.opusmeetingrooms.com/mrapi/v1/index.php';

  }
  getLogin(name, pass, method, action) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'username=' + name
              + '&password=' + pass
              + '&object=' + method
              + '&action=' + action;
        return this.http.post(this.baseUrl, form, options);
  }

  getCity(authcode) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'authcode=' + authcode
              + '&object=Cities'
              + '&action=list'
              + '&country=1';
        return this.http.post(this.baseUrl, form, options);
  }

  getRegister(f_name, l_name, email, pass, phone, c_name, code, ref, def_city) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'firstname=' + f_name
              + '&lastname=' + l_name
              + '&email=' + email
              + '&password=' + pass
              + '&phone=' + phone
              + '&object=Users'
              + '&action=register'
              + '&promocode=' + code
              + '&referralcode=' + ref
              + '&cityid=' + def_city
              + '&companyname=' + c_name;

        return this.http.post(this.baseUrl, form, options);
  }

  getBuildings(c_id, authcode) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'cityid=' + c_id
              + '&authcode=' + authcode
              + '&object=Buildings'
              + '&action=list';

        return this.http.post(this.baseUrl, form, options);
  }

  getRooms(b_id, authcode) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'buildingid=' + b_id
              + '&authcode=' + authcode
              + '&object=Rooms'
              + '&action=list';
        return this.http.post(this.baseUrl, form, options);
  }

  getBuildingsMeeting(b_id, authcode, stdt, ltdt) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'buildingid=' + b_id
              + '&authcode=' + authcode
              + '&object=BuildingMeeting'
              + '&action=list'
              + '&fromdate=' + stdt
              + '&todate=' + ltdt;
        return this.http.post(this.baseUrl, form, options);
  }

  addnewMeeting(authcode, r_id, t_from, t_to, e_name) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'authcode=' + authcode
              + '&roomid=' + r_id
              + '&fromdate=' + t_from
              + '&todate=' + t_to
              + '&description=' + e_name
              + '&object=Meetings'
              + '&action=add';

        return this.http.post(this.baseUrl, form, options);
  }

  eventDelete(m_id, authcode) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'id=' + m_id
              + '&authcode=' + authcode
              + '&object=Meetings'
              + '&action=del';

        return this.http.post(this.baseUrl, form, options);
  }

  getAllMeetings(authcode) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'authcode=' + authcode
              + '&object=UserMeeting'
              + '&action=list';

        return this.http.post(this.baseUrl, form, options);
  }

  getRoomsMeeting(r_id, authcode, stdt, ltdt) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'roomid=' + r_id
              + '&authcode=' + authcode
              + '&object=RoomMeeting'
              + '&action=list'
              + '&fromdate=' + stdt
              + '&todate=' + ltdt;

        return this.http.post(this.baseUrl, form, options);
  }

  getTransaction(authcode) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'authcode=' + authcode
              + '&object=Transactions'
              + '&action=list'
              + '&fromdate=""'
              + '&todate=""';

        return this.http.post(this.baseUrl, form, options);
  }

  eventEdit(m_id, authcode, t_from, t_to, e_name) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'id=' + m_id
              + '&authcode=' + authcode
              + '&fromdate=' + t_from
              + '&todate=' + t_to
              + '&description=' + e_name
              + '&object=Meetings'
              + '&action=upd';

        return this.http.post(this.baseUrl, form, options);
  }

  getUserdata(authcode) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'authcode=' + authcode
              + '&object=Users'
              + '&action=list';

        return this.http.post(this.baseUrl, form, options);
  }

  updateUser(authcode, f_name, l_name, c_name, email, phone, d_city ) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'firstname=' + f_name
              + '&authcode=' + authcode
              + '&lastname=' + l_name
              + '&companyname=' + c_name
              + '&email=' + email
              + '&phone=' + phone
              + '&defaultcity=' + d_city
              + '&object=Users'
              + '&action=update';

        return this.http.post(this.baseUrl, form, options);
  }

  getavailHours(authcode) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'authcode=' + authcode
              + '&object=Users'
              + '&action=hours';

        return this.http.post(this.baseUrl, form, options);
  }

  forgetPass(object, action, email) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'object=' + object
               + '&action=' + action
               + '&email=' + email;

        return this.http.post(this.baseUrl, form, options);
  }

  ResetPassword(pass1, pass2, code) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'password=' + pass1
               + '&confirmpassword=' + pass2
               + '&resetcode=' + code
               + '&action=reset'
               + '&object=Users';

        return this.http.post(this.baseUrl, form, options);
  }

  logout(authcode) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = '&authcode=' + authcode
               + '&action=logout'
               + '&object=Login';

        return this.http.post(this.baseUrl, form, options);
  }

  saveCard(c_num, name, month, year, cvv, addr, city, zip, state, authcode) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'cardnumber=' + c_num
              + '&cardname=' + name
              + '&cardmonth=' + month
              + '&cardyear=' + year
              + '&cardcvv=' + cvv
              + '&billingaddress=' + addr
              + '&billingcity=' + city
              + '&billingstate=' + state
              + '&billingzip=' + zip
              + '&authcode=' + authcode
              + '&action=save'
              + '&object=Card';
        return this.http.post(this.baseUrl, form, options);
  }

  useSavedCard(authcode, uid, amount, cardid, cvv, hour) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'authcode=' + authcode
               + '&action=charge'
               + '&object=Card'
               + '&amount=' + amount
               + '&hours=' + hour
               + '&cardid=' + cardid
               + '&cvv=' + cvv
               + '&userid=' + uid;
        return this.http.post(this.baseUrl, form, options);
  }

  reset(authcode, pass, n_pass, c_pass) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'authcode=' + authcode
               + '&action=password'
               + '&object=Users'
               + '&currentpassword=' + pass
               + '&newpassword=' + n_pass
               + '&confirmpassword=' + c_pass;
        return this.http.post(this.baseUrl, form, options);
  }

  GetSavedCards(authcode) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'authcode=' + authcode
               + '&action=list'
               + '&object=Card';
        return this.http.post(this.baseUrl, form, options);
  }

  updateSavedCard(authcode, cvv, addr, month, year, cid, name, city, zip, state) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'cardid=' + cid
              + '&cardname=' + name
              + '&cardmonth=' + month
              + '&cardyear=' + year
              + '&cardcvv=' + cvv
              + '&billingaddress=' + addr
              + '&billingcity=' + city
              + '&billingstate=' + state
              + '&billingzip=' + zip
              + '&authcode=' + authcode
              + '&action=update'
              + '&object=Card';
        return this.http.post(this.baseUrl, form, options);
  }

  deleteSavedCard(authcode, cid) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'authcode=' + authcode
               + '&action=delete'
               + '&object=Card'
               + '&cardid=' + cid;
        return this.http.post(this.baseUrl, form, options);
  }

  getBuildingAddress(b_id) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { headers: headers };
    const form = 'buildingid=' + b_id
               + '&action=address'
               + '&object=Buildings';
        return this.http.post(this.baseUrl, form, options);
  }


}
